import React from 'react';
import { MaterialIcons } from '@iclinic/design-system';

const { Contacts, AssignmentTurnedInRounded } = MaterialIcons;

type AddonContent = {
  description: (value?: string, recurrence?: string) => string;
  icon: React.ReactElement;
};

type AddonContentByPlan = {
  [key: string]: {
    [key: string]: AddonContent;
  };
};

type TitleModalByAddonSlug = {
  [key: string]: (isAnnual: boolean) => string;
};

const telemedicine: AddonContent = {
  description: (value?: string, recurrence?: string) =>
    `Adicionar 10 teleconsultas por R$ ${value || ''}/${recurrence || ''}`,
  icon: <Contacts />,
};

const electronicSignature: AddonContent = {
  description: (value?: string, recurrence?: string) =>
    `Adicionar assinatura eletrônica do paciente por R$ ${value || ''}/${
      recurrence || ''
    }`,
  icon: <AssignmentTurnedInRounded />,
};

export const addonsContentByPlan: AddonContentByPlan = {
  premium: {
    telemedicine: {
      description: () => 'Teleconsultas ilimitadas neste plano',
      icon: <Contacts />,
    },
    'electronic-signature': electronicSignature,
  },
  pro: { telemedicine, 'electronic-signature': electronicSignature },
  plus: { telemedicine, 'electronic-signature': electronicSignature },
  starter: { telemedicine, 'electronic-signature': electronicSignature },
};

export const titleModalSelectPhysiciansByAddonSlug: TitleModalByAddonSlug = {
  telemedicine: (isAnnual: boolean) =>
    `Você está adicionando um pacote de 10 teleconsultas ${
      isAnnual ? 'anuais' : 'mensais'
    } na sua assinatura.`,
  'electronic-signature': () =>
    `Você está adicionando o pacote de assinatura eletrônica.`,
};
